import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const slides = [
  {
    title: "Coaching and Training",
    points: [
      "Professional-led Training",
      "Learn the fundamentals every footballer needs",
      "Increase fitness levels",
    ],
    cta: "Skip",
  },
  {
    title: "Personalized Training Program",
    points: [
      "Pick your favourite skills",
      "Build your own sessions",
      "Grow your confidence",
    ],
    cta: "Skip",
  },
  {
    title: "Match Tracker, Challenges, Tricks and more",
    points: [
      "Log your personal stats each week",
      "Take on fun challenges",
      "Record your performance from matches",
    ],
    cta: "Skip",
  },
  {
    title: "",
    points: [
      "Take advantage of our 7 Day Free Trial across all subscriptions to show you how eCoachPro can improve your fitness and skill levels!",
    ],
    cta: "Continue",
  },
];

/* =======================
   Animation Variants
======================= */

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.15 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

const logoVariants = {
  hidden: { opacity: 0, y: -40, scale: 0.8 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6 },
  },
  exit: {
    opacity: 0,
    y: -40,
    scale: 0.8,
    transition: { duration: 0.3 },
  },
};

/* =======================
   Swipe Helpers
======================= */

const swipeConfidenceThreshold = 100;

const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};

/* =======================
   Component
======================= */

export default function SplashSlider({ onFinish }) {
  const [index, setIndex] = useState(0);

  const handleCTA = () => {
    if (index < slides.length - 1) {
      setIndex(index + 1);
    } else {
      onFinish();
    }
  };

  return (
    <div className="splash">
      {/* Logo */}
      <AnimatePresence mode="wait">
        <motion.img
          key={index}
          src="/image/splash-logo.png"
          alt="eCoachPro"
          className="splash-logo"
          variants={logoVariants}
          initial="hidden"
          animate="show"
          exit="exit"
        />
      </AnimatePresence>

      {/* Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          className="splash-content"
          variants={containerVariants}
          initial="hidden"
          animate="show"
          exit={{ opacity: 0 }}
          drag="x"
          dragConstraints={{ left: 0, right: 0 }}
          dragElastic={0.8}
                    onDragEnd={(e, { offset, velocity }) => {
            const swipe = swipePower(offset.x, velocity.x);

            if (swipe < -swipeConfidenceThreshold) {
              handleCTA();
            } else if (swipe > swipeConfidenceThreshold && index > 0) {
              setIndex(index - 1);
            }
          }}
        >
          {slides[index].title && (
            <motion.h2
              variants={itemVariants}
              className="splash-title"
            >
              {slides[index].title}
            </motion.h2>
          )}

          <div className="d-flex flex-wrap justify-content-center align-items-center gap-3">
            {slides[index].points.map((text, i) => (
              <motion.p
                key={i}
                variants={itemVariants}
                className={`tip splash-points mb-0 ${
                  index === slides.length - 1 ? "last-slide-point" : ""
                }`}
              >
                {text}
              </motion.p>
            ))}
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Footer */}
      <div>
        {/* Dots */}
        <div className="splash-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              className={`dot ${index === i ? "active" : ""}`}
            />
          ))}
        </div>

        {/* CTA */}
        <button className="splash-cta" onClick={handleCTA}>
          {slides[index].cta}
        </button>
      </div>
    </div>
  );
}
